import type { AnnouncementAudienceChoice } from '@gto/api-client/admin/react-query'

/**
 * Every base audience the BE's enum accepts, widest first, which is the order
 * the form's audience select already reads in.
 *
 * The URL schema validates against this same list, so a pasted audience the
 * endpoint would answer with a 422 falls back to the unfiltered list instead.
 */
export const AUDIENCE_CHOICES = [
  'all',
  'free',
  'trial',
  'paid',
] as const satisfies readonly AnnouncementAudienceChoice[]

/**
 * Short staff-facing labels for each base audience. Kept out of i18n because
 * admin-web is English-only staff tooling — see apps/admin-web/README.md.
 *
 * Lives here rather than beside the table so the filter and the Audience column
 * name an audience identically: a dropdown reading "Trial" has to select the
 * rows whose column starts with "Trial".
 */
export const AUDIENCE_LABEL: Record<AnnouncementAudienceChoice, string> = {
  all: 'All',
  free: 'Free',
  trial: 'Trial',
  paid: 'Paid',
}
